export default __webpack_public_path__ + "static/media/es.191391a8.svg";